import { defineAsyncComponent } from 'vue'
import { createApp, type ModuleConfig } from '@bridge2ai/core/frontend'
import config from './config/modules.config.json'
import terminology from '../../terminology.json'
import { startPoAttention } from './modules/po-confirmations/attention'

// Tenant-local RST modules.
const customModules: ModuleConfig[] = [
  {
    id: 'poConfirmations',
    moduleId: 'po-confirmations',
    slug: 'po-confirmations',
    name: 'PO Confirmations',
    iconUrl: '/icons/po-confirmations.svg',
    componentLoader: () =>
      defineAsyncComponent(() => import('./modules/po-confirmations/PoConfirmations.vue')),
  },
  {
    id: 'productionStatus',
    moduleId: 'production-status',
    slug: 'production-status',
    name: 'Production Status',
    iconUrl: '/icons/reports.svg',
    componentLoader: () =>
      defineAsyncComponent(() => import('./modules/production-status/ProductionStatus.vue')),
  },
  {
    id: 'baqReports',
    moduleId: 'baq-reports',
    slug: 'baq-reports',
    name: 'BAQ Reports',
    iconUrl: '/icons/reports.svg',
    componentLoader: () =>
      defineAsyncComponent(() => import('./modules/baq-reports/BaqReports.vue')),
  },
]

createApp({
  tenantId: 'rst',
  config: config as any,
  customModules,
  // Tenant UI pack: RST keeps Core's default terminology/fields/views —
  // declared explicitly so the extension point is exercised in production.
  // The ERP hooks below point Core's generic UI at RST's own Epicor traffic:
  // the Import Data window runs the `epicor-jobs` sync adapter through
  // /api/sync, the schedule push runs the `epicor-dates` push-back through
  // /api/push, and the actuals feed hits /api/epicor.
  tenant: {
    apiVersion: 1,
    terminology: terminology as any,
    sync: { label: 'Sync Epicor', adapter: 'epicor-jobs' },
    pushSchedule: { label: 'Approve & Push to Epicor', pushback: 'epicor-dates' },
    actualsEndpoint: '/api/epicor/actuals',
  },
}).then(() => {
  // The PO Confirmations badge (open discrepancy flags) has to show before anyone opens the module, so its
  // source starts here, once the shell store exists, rather than inside the module.
  startPoAttention()
})
